import React, { useEffect, useState, useContext } from 'react'
import MapContext from './MapContext'

const TerrainControl = (props) => {
  const map = useContext(MapContext)
  const [pitch, setPitch] = useState((map) ? map.getPitch() > 0 : false)

  useEffect(() => {
    if (!map) return

    const mapChangeHandler = () => {
      setPitch(map.getPitch() > 0)
    }
    map.on('pitchend', mapChangeHandler)
    mapChangeHandler()

    return () => {
      if (map && map.off) {
        map.off('pitchend', mapChangeHandler)
      }
    }
  }, [map])

  const className = pitch ? "secondary active" : "basic" 
  const handler = (e) => {
    if (pitch) {
        map.easeTo({pitch: 0}, {originalEvent: e})
    } else {
        map.easeTo({pitch: 60}, {originalEvent: e})
    }
  }

  return (
    <button className={"button circular fa " + className }
            onClick={ handler }>
        3D
    </button>
  )
}

export default TerrainControl
